
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import Logbuch from '@/types/Logbuch';

    @Component
    export default class LogbuchEintragDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() eintrag!: Logbuch;
    }
